<div class="flex-control flex-column">
  <app-tabs>
    <li (click)="_tabs_service.deactivate_tab()" [class.active]="!_tabs_service.is_active()">Templates</li>
  </app-tabs>
  <div class="flex-control flex-column" [hidden]="_tabs_service.is_active()">
    <app-templates-filter class="flex-header"></app-templates-filter>
    <app-templates-listing class="flex-body p scroll-browser"></app-templates-listing>
  </div>
</div>
